const hoy = new Date();
const ayer = new Date(hoy);
ayer.setDate(hoy.getDate() - 1);

export const globalStartDate = ayer;
export const globalEndDate = hoy;

// Primer y último día del mes
export const firstDay = new Date(globalStartDate.getFullYear(), globalStartDate.getMonth(), 1);
export const lastDay = new Date(globalEndDate.getFullYear(), globalEndDate.getMonth() + 1, 0);
